import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { historialEntregasHologramas } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { v4 as uuidv4 } from 'uuid';
import { buscarSolicitudByFolio } from '../../../redux/DuckUsuarioDeveloper/SolicitudesDevDuck';
import { IniciarProceso, IniciarProceso2 } from '../../../redux/DuckUsuarioDeveloper/ConstanciasDevDuck';

const ConstanciasDevComponent = () => {

    const dispatch = useDispatch()
    const solicitudesDev = useSelector(store => store.UsuarioDeveloper.solicitudesDev)

    const [files, setFiles] = React.useState([])
    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles(selectedFiles);
    };
    const buscarSolicitud = async () => {
        await dispatch(IniciarProceso(files))
    }


    const buscarSolicitud2 = async () => {
        await dispatch(IniciarProceso2(files))
    }

    return (
        <div className="container" style={{ height: 500 }}>

            <div className='row' style={{ marginTop: '5%', alignContent: 'center', justifyContent: 'center' }}>
                <input type="file" accept=".kml" multiple onChange={handleFileChange} />
                <button onClick={() => buscarSolicitud()} className='btn btn-outline-success'>INICIAR PROCESO MIGRACIÓN</button>
                <button onClick={() => buscarSolicitud2()} className='btn btn-outline-success'>INICIAR PROCESO MIGRACIÓN 2</button>
            </div>

        </div>
    );

};
export default ConstanciasDevComponent